import React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { plPL } from '@material-ui/core/locale';
import { routes } from 'app/shared/constants';

import { Layout } from 'app/components/Layout/Layout';
import HomePage from 'app/containers/HomePage/HomePage';
import LoginPage from 'app/containers/LoginPage/LoginPage';
import RegisterPage from 'app/containers/RegisterPage/RegisterPage';
import LogoutPage from 'app/containers/LogoutPage/LogoutPage';
import SuppliersPage from 'app/containers/SuppliersPage/SuppliersPage';
import MaterialsPage from 'app/containers/MaterialsPage/MaterialsPage';
import ActionsPage from 'app/containers/ActionsPage/ActionsPage';
import ResourcesPage from 'app/containers/ResourcesPage/ResourcesPage';
import ScenariosPage from 'app/containers/ScenariosPage/ScenariosPage';
import ProductsPage from 'app/containers/ProductsPage/ProductsPage';
import FactoryPage from 'app/containers/FactoryPage/FactoryPage';
import FactoriesPage from 'app/containers/FactoriesPage/FactoriesPage';
import ProcessesPage from 'app/containers/ProcessesPage/ProcessesPage';
import MaterialTypesPage from 'app/containers/MaterialTypesPage/MaterialTypesPage';
import ResourceTypesPage from 'app/containers/ResourceTypesPage/ResourceTypesPage';
import ActionTypesPage from 'app/containers/ActionTypesPage/ActionTypesPage';
import RoomsPage from 'app/containers/RoomPage/RoomPage';
import RoomArchivePage from 'app/containers/RoomArchivePage/RoomArchivePage';
import GameViewPage from 'app/containers/GameViewPage/GameViewPage';
import PlayerRoomsPage from 'app/containers/PlayerRoomsPage/PlayerRoomsPage';
import OrderPage from 'app/containers/OrderPage/OrderPage';
import GanttsPage from 'app/containers/GanttsPage/GanttsPage';
import GanttPage from 'app/containers/GanttPage/GanttPage';
import UsersPage from 'app/containers/UsersPage/UsersPage';
import DistributionTemplatesPage from 'app/containers/DistributionTemplatesPage/DistributionTemplatesPage';

import { IsAuthorized } from 'app/components/IsAuthorized/IsAuthorized';
import { PrivateRoute } from 'app/components/PrivateRoute/PrivateRoute';

import { theme } from 'app/styles/theme';

import './App.css';

function App() {
  return (
    <div className={'App'}>
      <ThemeProvider theme={createMuiTheme(theme, plPL)}>
        <BrowserRouter>
          <Layout />
          <div className={'App-body'}>
            <Switch>
              <Route exact path={routes.LOGIN.route} component={LoginPage} />
              <Route exact path={routes.REGISTER.route} component={RegisterPage} />
              <IsAuthorized>
                <PrivateRoute route={routes.LOGOUT} component={LogoutPage} />
                <PrivateRoute route={routes.SUPPLIERS} component={SuppliersPage} />
                <PrivateRoute route={routes.MATERIALS} component={MaterialsPage} />
                <PrivateRoute route={routes.MATERIAL_TYPES} component={MaterialTypesPage} />
                <PrivateRoute route={routes.ACTIONS} component={ActionsPage} />
                <PrivateRoute route={routes.DISTRIBUTION_TEMPLATE} component={DistributionTemplatesPage} />
                <PrivateRoute route={routes.ACTION_TYPES} component={ActionTypesPage} />
                <PrivateRoute route={routes.RESOURCES} component={ResourcesPage} />
                <PrivateRoute route={routes.RESOURCE_TYPES} component={ResourceTypesPage} />
                <PrivateRoute route={routes.PRODUCTS} component={ProductsPage} />
                <PrivateRoute route={routes.PROCESSES} component={ProcessesPage} />
                <PrivateRoute route={routes.ORDERS} component={OrderPage} />
                <PrivateRoute route={routes.GANTTS} component={GanttsPage} />
                <PrivateRoute route={routes.GANTT} component={GanttPage} />
                <PrivateRoute route={routes.FACTORIES} component={FactoriesPage} />
                <PrivateRoute route={routes.FACTORY} component={FactoryPage} />
                <PrivateRoute route={routes.SCENARIOS} component={ScenariosPage} />
                <PrivateRoute route={routes.ROOMS} component={RoomsPage} />
                <PrivateRoute route={routes.GAME_VIEW} component={GameViewPage} />
                <PrivateRoute route={routes.PLAYER_ROOMS} component={PlayerRoomsPage} />
                <PrivateRoute route={routes.ROOMS_ARCHIVED} component={RoomArchivePage} />
                <PrivateRoute route={routes.USERS} component={UsersPage} />
                <PrivateRoute exact route={routes.HOME} component={HomePage} />
              </IsAuthorized>
            </Switch>
          </div>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
